import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
//import {i18next} from 'i18n.js';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import { ActionButton } from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import SimpleReactValidator from '../components/validator';
import ProfileService from '../services/ProfileService';

class PartnerApiAccessDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new ProfileService());
        this.state = {
            showValidationMessage: false,
            validatePasswords: false,
            isApiAccess: true,
            agreementAcceptation: false,
            element: {
                apiEmail: '',
                verificationCode: undefined,
            },
            verificationCode: undefined,
        };
        this.userAgreementMapId = this.authService.getProfile().userAgreementMapId;
        this.validator = new SimpleReactValidator({}, props.t);
        this.handlePasswordsMatch = this.handlePasswordsMatch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getVerificationType = this.getVerificationType.bind(this);
        this.handleGenerateVerificationCode = this.handleGenerateVerificationCode.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    initBeforeSetElement() {
    }

    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'>
                    <ActionButton 
                        label={t('details.cancel')}
                        variant={'button cancel-button white'}
                        handleClick={this.props.onHide}
                    />
                </div>
                <div className='left-footer-dialog-button-container'>
                    <ActionButton 
                        label={t('details.sendCode')}
                        variant={'button white'}
                        handleClick={this.handleGenerateVerificationCode}
                    />
                </div>
                <ActionButton
                    label={t('details.save')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    disabled={this.props.dialogType === 'API_ACCESS' && this.state.agreementAcceptation === false}
                />
            </div>
        );
    }

    renderEditEmailRequestHeader(){
        return  <DivContainer colClass='col-12 transaction-dialog-header'>
                  <DivContainer colClass='col-12'>
                     <label>{"Edycja adresu email"}</label>
                  </DivContainer>
              </DivContainer>
      }
    
    renderCodeVerificationRequestHeader(){
      return  <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                   <label>{"Weryfikacja kodu"}</label>
                </DivContainer>
            </DivContainer>
    }

    renderResignationHeader(){
        return  <DivContainer colClass='col-12 transaction-dialog-header'>
                  <DivContainer colClass='col-12'>
                     <label>{"Rezygnacja z dostępu do API "}</label>
                  </DivContainer>
              </DivContainer>
      }
  

    renderApiRequestHeader(){
        return  <DivContainer colClass='col-12 transaction-dialog-header'>
                  <DivContainer colClass='col-12'>
                  <label>{"Nadawanie dostępu do API"}</label>
                  </DivContainer>
              </DivContainer>


    {/* <label>{"Nadawanie dostępu do API"}</label> */}
    {/* <label>{"Weryfikacja kodu "}</label> */}
    {/* <div className='generate-report-from-template-header'>{"Rezygnacja z dostępu do API"}</div>
    <label>{"Wpisz kod weryfikacyjny, aby zrezygnować z dostępu"}</label> */}
    {/* <label>{"Edycja adresu email "}</label> */}


      }

    renderHeader() {
        const {t} = this.props;
        switch (this.props.dialogType) {
            case 'API_RESIGNATION':
                return this.renderResignationHeader();
            case 'API_ACCESS':
                return this.renderApiRequestHeader();
            case 'CODE_VERIFICATION':
                return this.renderCodeVerificationRequestHeader();
            case 'EDIT_EMAIL':
                return this.renderEditEmailRequestHeader();
            default:
                return [];
        }
        
    }

    // setElement() {
    //     this.initAfterSetElement();
    // }

    setElement() {

        if (this.props.element) {

            this.updateElement(this.props.element);
        }
    }

    createOrUpdate() {
        this.scrollToTop();
        if (this._isMounted) {
            this.blockUi();
            switch (this.props.dialogType) {
                case 'API_RESIGNATION':
                    return this.sendApiResignation();
                case 'API_ACCESS':
                    return this.addApiAccess();
                case 'CODE_VERIFICATION':
                    return this.viewApiUserPassword();
                case 'EDIT_EMAIL':
                    return this.editApiUserEmail();
                default:
                    return [];
            }
        }
    }

    addApiAccess(){
        if(this.props.dialogType === 'API_ACCESS'){
            this.service
            .addApiAccess({email: this.state.element.apiEmail, verificationCode: this.state.verificationCode})
            .then((response) => {
                this.unblockUi();
                if (this.props.handleSuccess) {
                    this.unblockUi();
                    this.props.handleSuccess(response);
                    this.showSuccessMessage("Dodano dostęp do API dla użytkownika")
                }
            })
            .catch((err) => {
                if (this.props.handleError) {
                    this.unblockUi();
                    this.props.handleError(err);
                }
       
               
            });
            
        }
    }

    sendApiResignation(){
        let vc = this.state.verificationCode;
        if(this.props.dialogType === 'API_RESIGNATION'){
            this.service
            .apiResignation(vc)
            .then((response) => {
                this.unblockUi();
                this.props.handleSuccess();
                this.showSuccessMessage("Zrezygnowano z dostępu do API")
            })
            .catch((err) => {
                if (this.props.handleError) {
                    this.unblockUi();
                    this.props.handleError(err);
                }
       
               
            });
            
        }
    }

    viewApiUserPassword(){
        let vc = this.state.verificationCode;
        if(this.props.dialogType === 'CODE_VERIFICATION'){
            this.service
            .verifyCodeRequestAndDisplayPassword(vc)
            .then((response) => {
                this.unblockUi();               
                this.props.apiAccessPassword(response);
            })
            .catch((err) => {
                if (this.props.handleError) {
                    this.unblockUi();
                    this.props.handleError(err);
                }
       
               
            });
            
        }
    }

    editApiUserEmail(){
        if(this.props.dialogType === 'EDIT_EMAIL'){
            this.service
            .updateApiAccessEmail({email: this.state.element.apiEmail, verificationCode: this.state.verificationCode})
            .then((response) => {
                this.unblockUi();
                if (this.props.handleSuccess) {
                    this.unblockUi();
                    this.props.handleSuccess(response);
                    this.showSuccessMessage("Adres email partnera został zaktualizowany")
                }
            })
            .catch((err) => {
                if (this.props.handleError) {
                    this.unblockUi();
                    this.props.handleError(err);
                }
       
            });
            
        }
    }

    getVerificationType() {
        switch (this.props.dialogType) {
            case 'API_ACCESS': 
                return 'API_ACCESS';
            case 'API_RESIGNATION': 
                return 'API_RESIGNATION';
            case 'EDIT_EMAIL':
            case 'CODE_VERIFICATION': 
                return 'VERIFICATION';
            default: 
                return '';
        }
    }

    handleGenerateVerificationCode() {
        const verificationType = this.getVerificationType();
        this.service.generateVerificationCodeRequest(verificationType)
            .then(() => {
                this.showSuccessMessage("Kod weryfikacyjny został wysłany");
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            this.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.setState({
                validatePasswords: true,
            });
            this.forceUpdate();
        }
    }

    handlePasswordsMatch() {
        const {newPassword, repeatPassword} = this.state;
        if (newPassword.length > 0 && repeatPassword.length > 0 && newPassword !== repeatPassword) {
            this.setState({showValidationMessage: true});
            return false;
        } else {
            this.setState({showValidationMessage: false});
            return true;
        }
    }

    renderDetails() {
        const {t, authCodeSentBy} = this.props;
        return (
            <React.Fragment>
                    <InputTextComponent
                        id='apiEmail'
                        // eslint-disable-next-line max-len
                        label={"Email"}
                        name='apiEmail'
                        value={this.state.element.apiEmail}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode='EDIT'
                        validators='required|email'
                        colClass='col-12 '
                        feedback={false}
                        stateField='element'
                        rendered={this.props.dialogType === 'API_ACCESS' || this.props.dialogType === 'EDIT_EMAIL'}
                    />
                       {this.props.dialogType === 'API_RESIGNATION'? 
                            <span style={{fontWeight:'400', fontSize:'smaller'}}>{"Wpisz kod weryfikacyjny, aby zrezygnować z dostępu"}</span>: null   
                     } 
                     {this.props.dialogType === 'CODE_VERIFICATION' || this.props.dialogType === 'EDIT_EMAIL'? 
                     <div style={this.props.dialogType === 'EDIT_EMAIL' ? {marginTop: '30px'} : null}> <span style={{fontWeight:'400', fontSize:'smaller', marginTop:'40px'}}>{"Wpisz kod weryfikacyjny, który otrzymałeś "} {authCodeSentBy === 'SMS' ? "SMS-em" : "na adres e-mail"}</span>  </div>
                                         : null
                     } 



                        <InputTextComponent
                        id='verificationCode'
                        // eslint-disable-next-line max-len
                        label={"Kod weryfikacyjny"}
                        name='verificationCode'
                        value={this.state.verificationCode}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode='EDIT'
                        validators='required'
                        colClass='col-12 '
                        feedback={false}
                        stateField=''
                    />
                    <div style={{marginTop:'10px', marginBottom:'20px'}}>
                    <InputCheckboxComponent
                        id={'agreementAcceptation'}
                        name='agreementAcceptation'
                        label={"Zgoda/Akceptacja regulaminu"}
                        labelOnRight
                        value={this.state.agreementAcceptation}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators='required'
                        disabled={this.props.cardKind === 'VEHICLE' || this.props.cardKind === 'VEHICLE_PERSON'}
                        colClass='col-12'
                        renderRequired
                        stateField=''
                        rendered={this.props.dialogType === 'API_ACCESS'}
                    />
                    </div>
                      
            </React.Fragment>
        );
    }
}

PartnerApiAccessDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
    dialogType: 'API_RESIGNATION',
    authCodeSentBy: 'EMAIL'
};

PartnerApiAccessDialog.propTypes = {
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    handleSuccess: PropTypes.func,
    handleError: PropTypes.func,
    dialogType: PropTypes.string,
    apiAccessPassword: PropTypes.func,
    authCodeSentBy: PropTypes.bool,
};

export default withTranslation()(PartnerApiAccessDialog);

